(function(){
  var header=document.querySelector('.header');
  addEventListener('scroll',function(){header&&header.classList.toggle('is-scrolled',scrollY>8)},{passive:true});
  var tog=document.querySelector('.menu-toggle'),nav=document.getElementById('nav');
  if(tog&&nav)tog.addEventListener('click',function(){var o=nav.classList.toggle('is-open');tog.setAttribute('aria-expanded',o)});
  var toast=document.querySelector('[data-toast]');
  function say(m){if(!toast)return;toast.textContent=m;toast.classList.add('is-on');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('is-on')},2400)}
  function count(){fetch('/cart.js').then(function(r){return r.json()}).then(function(c){document.querySelectorAll('[data-count]').forEach(function(e){e.textContent=c.item_count})})}
  document.addEventListener('submit',function(e){
    var f=e.target;if(!f.matches('form[action*="/cart/add"]'))return;
    e.preventDefault();var btn=f.querySelector('[type=submit]');if(btn)btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(function(item){say(item.product_title+' added to bag');count()})
      .catch(function(err){say((err&&err.description)||'Could not add to bag. Try again.')})
      .finally(function(){if(btn)btn.disabled=false});
  });
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-qty]');if(!b)return;
    var i=b.parentNode.querySelector('input');i.value=Math.max(parseInt(i.min||0),(parseInt(i.value)||0)+parseInt(b.dataset.qty));
  });
})();
